import {Injectable} from "@angular/core";
import {ToastrService} from "ngx-toastr";

@Injectable({
  providedIn: "root"
})
export class NotificationsService {
  constructor(private toastrService: ToastrService) {}

  public success(text: string, title: string = null) {
    this.toastrService.success(text, title);
  }

  public error(text: string, title: string = null) {
    this.toastrService.error(text, title);
  }
}
